// Profile Page
import { renderHeader, renderBottomNav } from '../components/header.js';
import { getCurrentUser, isAdmin } from '../auth.js';
import { toastSuccess } from '../components/toast.js';
import { saveUser, getBookingsByUser, getAdminSettingsDB } from '../services/db.js';
import { isFirebaseReady } from '../firebase.js';
import { demoBookings } from '../data/demo-store.js';
import { t } from '../i18n.js';
import { showAlert, showPrompt } from '../utils/dialog.js';

export async function renderProfile() {
  const user = getCurrentUser();
  
  const app = document.getElementById('app');
  // Show loading while fetching stats
  app.innerHTML = `
    ${renderHeader()}
    <div class="page">
      <div style="text-align:center; padding: var(--space-xl);">
        <div class="loading-spinner"></div>
      </div>
    </div>
    ${renderBottomNav('profile')}
  `;

  let myBookings = [];
  if (isFirebaseReady()) {
    myBookings = await getBookingsByUser(user.id);
  } else {
    myBookings = demoBookings.filter(b => b.user_id === user.id);
  }

  const confirmedCount = myBookings.filter(b => b.status === 'confirmed').length;
  const admin = isAdmin();
  app.innerHTML = `
    ${renderHeader()}
    <div class="page">
      <div style="text-align:center; margin-bottom: var(--space-xl);">
        <img src="${user.pictureUrl || 'https://ui-avatars.com/api/?name=U&background=9b59f0&color=fff&size=100'}" 
             alt="${user.name}" 
             style="width:100px; height:100px; border-radius:50%; object-fit:cover; margin-bottom:var(--space-md); border:3px solid var(--accent-gold);" 
             onerror="this.onerror=null; this.src='https://ui-avatars.com/api/?name=U&background=9b59f0&color=fff&size=100'" />
        <h2 style="font-size: var(--font-xl); font-weight:700;">${user.name}</h2>
        <p class="text-sm text-muted">${admin ? t('profile_role_admin') : t('profile_role_user')}</p>
      </div>

      <!-- Stats -->
      <div class="stat-grid mb-lg">
        <div class="stat-card">
          <div class="stat-value">${myBookings.length}</div>
          <div class="stat-label">${t('profile_stat_total')}</div>
        </div>
        <div class="stat-card">
          <div class="stat-value">${confirmedCount}</div>
          <div class="stat-label">${t('profile_stat_confirmed')}</div>
        </div>
      </div>

      <!-- Info -->
      <div class="card mb-lg">
        <h3 style="color: var(--accent-gold); margin-bottom: var(--space-md);">📝 ${t('profile_title')}</h3>
        <div class="form-group">
          <label class="form-label">${t('profile_lbl_name')}</label>
          <input class="form-input" type="text" value="${user.name}" id="profile-name" />
        </div>
        <div class="form-group">
          <label class="form-label">${t('payment_lbl_tel')}</label>
          <input class="form-input" type="tel" value="${user.phone || ''}" placeholder="0812345678" id="profile-phone" />
        </div>
        <button class="btn btn-primary btn-block" id="save-profile-btn">💾 ${t('btn_save')}</button>
      </div>

      <div style="text-align:center; margin-bottom: var(--space-lg);">
        <a href="https://line.me/ti/p/@vtx4482v" target="_blank" class="btn btn-outline" style="border-color: #06C755; color: #06C755;">
          💬 ${t('btn_contact_admin') || 'ติดต่อแอดมิน (@vtx4482v)'}
        </a>
      </div>

      ${user.role === 'admin' ? `
        <div class="card mb-lg" style="background: linear-gradient(135deg, rgba(155,89,240,0.1), rgba(233,77,158,0.1)); border-color: rgba(233,77,158,0.3);">
          <div style="display:flex; justify-content:space-between; align-items:center;">
            <div>
              <p class="fw-600 text-gold">เข้าสู่หน้าแอดมิน</p>
              <p class="text-xs text-muted">จัดการการจอง, ตารางเวลา, ตั้งค่าระบบ</p>
            </div>
            <button class="btn btn-sm btn-gold" onclick="location.hash='#/admin/bookings'">เข้า →</button>
          </div>
        </div>
      ` : `
        <div style="text-align:center; margin-bottom: var(--space-lg);">
           <button id="upgrade-admin-btn" class="btn btn-outline" style="border:none; color:var(--text-muted); font-size:var(--font-sm);">
             🔑 สำหรับอาจารย์/แอดมินระบบ
           </button>
        </div>
      `}

      <div class="mt-lg text-center">
        <p class="text-xs text-muted">LINE User ID: ${user.id}</p>
        <p class="text-xs text-muted mt-sm">Astrology App v1.0.0</p>
      </div>
    </div>
    ${renderBottomNav('profile')}
  `;

  document.getElementById('save-profile-btn')?.addEventListener('click', async () => {
    const btn = document.getElementById('save-profile-btn');
    btn.disabled = true;
    btn.textContent = '⏳ ...';

    const name = document.getElementById('profile-name')?.value;
    const phone = document.getElementById('profile-phone')?.value;
    if (name) user.name = name;
    if (phone) user.phone = phone;

    await saveUser(user);
    toastSuccess(t('toast_save_success'));
    renderProfile();
  });

  document.getElementById('upgrade-admin-btn')?.addEventListener('click', async () => {
    const pin = await showPrompt('กรุณากรอกรหัส PIN คุมระบบ เพื่อเปิดสิทธิ์การแจ้งเตือนและการจัดการ:');
    if (!pin) return;
    
    let expectedPin = '888888';
    try {
      const settings = await getAdminSettingsDB();
      if (settings && settings.system_pin) {
        expectedPin = settings.system_pin;
      }
    } catch (e) {
      console.warn('Could not fetch settings, using default pin');
    }

    if (pin === expectedPin) {
      user.role = 'admin';
      await saveUser(user);
      toastSuccess('ยินดีต้อนรับเข้าสู่ระบบจัดการ (คุณจะได้รับแจ้งเตือนทางไลน์แล้ว)');
      renderProfile();
    } else {
      await showAlert('❌ รหัส PIN ไม่ถูกต้อง');
    }
  });
}
